import { Injectable } from '@angular/core';
import { sha256 } from 'js-sha256';

@Injectable({
  providedIn: 'root'
})
export class ObjectSnapshotService {
  /**
   * Extract only the specified fields from an object (supports nested fields).
   */
  extractFields(obj: Record<string, any>, fieldList: string): Record<string, any> {
    const result: Record<string, any> = {};
    const fields = fieldList.split(',').map(f => f.trim());
  
    for (const field of fields) {
      const path = field.split('.');
      this.applyPath(obj, path, result);
    }
  
    return result;
  }
  
  private applyPath(source: any, path: string[], target: any): void {
    const [current, ...rest] = path;
    if (!current) return;
  
    const isArray = current.endsWith('[]');
    const key = isArray ? current.slice(0, -2) : current;
  
    if (!(key in source)) return;
  
    if (isArray) {
      const sourceArray = source[key];
      if (!Array.isArray(sourceArray)) return;
  
      // Ensure target[key] is an array of the same length
      if (!Array.isArray(target[key])) {
        target[key] = [];
      }
  
      for (let i = 0; i < sourceArray.length; i++) {
        const srcItem = sourceArray[i];
        const tgtItem = target[key][i] || {};
        this.applyPath(srcItem, rest, tgtItem);
        target[key][i] = tgtItem;
      }
    } else if (rest.length === 0) {
      target[key] = source[key];
    } else {
      target[key] = target[key] || {};
      this.applyPath(source[key], rest, target[key]);
    }
  }
  
  

  /**
   * Stringify object in stable order.
   */
  toStableJson(obj: Record<string, any>): string {
    return JSON.stringify(obj);
  }

  /**
   * Get hash of the selected fields.
   */
  getSnapshotHash(obj: Record<string, any>, fieldList: string): string {
    const extracted = this.extractFields(obj, fieldList);
    const json = this.toStableJson(extracted);
    return sha256(json);
  }
}
